import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Users, Heart } from "lucide-react";

export default function CommunityPage() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/community/feed").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-12 text-center text-slate-500">Loading…</div>;
  if (!user) return <div className="p-12 text-center text-slate-500">Log in to see your community.</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-fredoka text-3xl sm:text-4xl font-bold text-slate-900 flex items-center gap-2" data-testid="community-title">
        <Users strokeWidth={2.5}/> Your Neighborhood
      </h1>
      <p className="text-slate-600 mt-1">What's happening at <b>{data?.community || "your community"}</b>. Names stay anonymous.</p>

      <div className="mt-6 space-y-3" data-testid="community-feed">
        {!data || data.items.length === 0 ? (
          <div className="card-clay p-8 text-center text-slate-400">No activity yet — be the first!</div>
        ) : (
          data.items.map((it, i) => (
            <div key={i} className="card-clay p-4 flex items-start gap-3" data-testid={`community-item-${i}`}>
              <div className="w-10 h-10 rounded-2xl bg-green-100 text-green-700 flex items-center justify-center flex-shrink-0">
                {it.kind === "badge" && "🏅"}
                {it.kind === "joins" && "👋"}
                {it.kind === "coverage" && "📣"}
              </div>
              <div className="text-sm text-slate-800 flex-1">{it.text}</div>
            </div>
          ))
        )}
      </div>

      <div className="card-clay p-5 mt-6 bg-amber-50 border-amber-200 flex items-center gap-3" data-testid="community-cta">
        <Heart className="text-amber-600" strokeWidth={2.5}/>
        <div className="flex-1 text-sm text-amber-900">Help your community grow — refer a neighbor and earn 100 points.</div>
        <Link to="/dashboard" className="btn-push-amber px-4 py-2 text-xs whitespace-nowrap">Share my code</Link>
      </div>
    </div>
  );
}
